'use strict';

var validateImage = require('./components/validateImage');

module.exports = {

    initiconCarousel: function () {
        var productCarousel = $('#personalization-slider-2');

        productCarousel.slick({
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 9,
                        slidesToScroll: 9,
                        infinite: false,
                        dots: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }]
        });
    },

    initEngCarousel: function () {
        var productCarousel = $('.engraving__slider');

        productCarousel.slick({
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: false,
                        dots: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }]
        });
    },

    initProductCarousel: function () {
        $('body').on('init:productCarousel', function () {
            var productCarousel = $('.js-p-carousel');
            productCarousel.not('.slick-initialized').slick({
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                infinite: false,
                autoplay: false,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        dots: false
                    }
                }, {
                    breakpoint: 787,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: false
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 300,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        arrows: false,
                        dots: true,
                        adaptiveHeight: true
                    }
                }]
            });
        });

        $('body').trigger('init:productCarousel');
    },

    initColorCarousel: function () {
        var colorCarousel = $('.js-color-carousel');
        colorCarousel.slick({
            mobileFirst: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: false,
            infinite: false,

            autoplay: false,
            responsive: [{
                breakpoint: 991,
                settings: 'unslick'
            }, {
                breakpoint: 787,
                settings: {
                    slidesToShow: 8,
                    slidesToScroll: 8,
                    dots: false
                }
            }, {
                breakpoint: 600,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    arrows: false,
                    dots: true
                }
            },
            {
                breakpoint: 300,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    arrows: false,
                    dots: true,
                    adaptiveHeight: true
                }
            }]
        });
    },

    initMobileOnlyCarousel: function () {
        var mobileOnlyCarousel = $('.js-mobile-carousel .grid-container');
        mobileOnlyCarousel.slick({
            mobileFirst: true,
            dots: true,
            arrows: false,
            infinite: false,

            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 600,
                settings: 'unslick'
            }]
        });
    },

    initCarouselVertical: function () {
        var verticalCarousel = $('.pdp-carousel-vertical');
        var verticalCarouselNav = $('.pdp-carousel-nav-vertical');
        if (!$(verticalCarousel).hasClass('new-pdp-layout-carousel') || $(window).width() < 768) {
            verticalCarousel.slick({
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                accessibility: true,
                infinite: false,
                arrows: false,
                focusOnSelect: true,
                dots: true,
                rows: 0,
                asNavFor: $('.new-pdp-layout-carousel').length > 0 ? '' : '.pdp-carousel-nav-vertical',
                responsive: [{
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        dots: false
                    }
                }]
            });
        }
        verticalCarouselNav.slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            mobileFirst: true,
            accessibility: true,
            vertical: true,
            infinite: false,
            asNavFor: '.pdp-carousel-vertical',
            dots: false,
            arrows: true,
            centerMode: false,
            rows: 0,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1439,
                    settings: {
                        slidesToShow: 6
                    }
                },
                {
                    breakpoint: 1239,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 4
                    }
                }
            ]
        });
    },

    initCarouselHorizontal: function () {
        var pdpCarousel = $('.pdp-carousel');
        var pdpCarouselNav = $('.pdp-carousel-nav');
        if (!$(pdpCarouselNav).hasClass('new-pdp-layout-carousel') || $(window).width() < 767) {
            pdpCarousel.not('.slick-initialized').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                accessibility: true,
                infinite: true,
                arrows: false,
                focusOnSelect: true,
                rows: 0,
                asNavFor: '.pdp-carousel-nav'
            });
        }
        pdpCarouselNav.not('.slick-initialized').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            accessibility: true,
            infinite: true,
            asNavFor: '.pdp-carousel',
            dots: false,
            arrows: true,
            centerMode: false,
            rows: 0,
            focusOnSelect: true
        });
    },

    initMatchSetCarousel: function () {
        $('body').on('init:matchSetCarousel', function () {
            var matchSetCarousel = $('.js-match-set-slider');

            matchSetCarousel.not('.slick-initialized').slick({
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                infinite: false,
                autoplay: false,
                adaptiveHeight: true,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                    }
                }, {
                    breakpoint: 787,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 300,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                    }
                }]
            });
        });

        $('body').trigger('init:matchSetCarousel');
    },

    bindScreenResize: function () {
        var colorCarousel = $('.js-color-carousel');
        var mobileOnlyCarousel = $('.js-mobile-carousel .grid-container');
        $(window).on('resize orientationchange', function () {
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() < 600) {
                if (!mobileOnlyCarousel.hasClass('slick-initialized')) {
                    module.exports.initMobileOnlyCarousel();
                }
            };
            if ($(window).width() < 991) {
                if (!colorCarousel.hasClass('slick-initialized')) {
                    module.exports.initColorCarousel();
                }
            };
        });
    },

    validateSliderImages: function () {
        $('.slick-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            validateImage.validatePictures();
        });
    },

    shopByColorProductCarousel: function () {
        var shopbycolorproductCarousel = $('.js-shopbycolor-carousel');
        shopbycolorproductCarousel.slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: false,
            autoplay: false,
            responsive: [{
                breakpoint: 1240,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: false
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: false
                }
            }, {
                breakpoint: 544,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 300,
                settings: {
                    slidesToShow: 8 / 7,
                    slidesToScroll: 1,
                }
            }]
        });
    },

    offersHubCarousel: function () {
        var offersHubCarousel = $('.js-offers-hub-slider');
        offersHubCarousel.slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: false,
            autoplay: false,
            responsive: [{
                breakpoint: 1240,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: false
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: false
                }
            }, {
                breakpoint: 544,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 300,
                settings: {
                    slidesToShow: 8 / 7,
                    slidesToScroll: 1,
                }
            }]
        });
    },
    // initOfferAndDealSlider: function () {
    //     $(window).on('load resize orientationchange', function () {
    //         var shopbycolorproductCarousel = $('.homepage-offer-section-wrapper');
    //         if ($(window).outerWidth() < 1240) {
    //             if (!$(".homepage-offer-section-wrapper").hasClass('slick-initialized')) {

    //                 shopbycolorproductCarousel.slick({
    //                     mobileFirst: true,
    //                     slidesToShow: 1.062,
    //                     slidesToScroll: 1,
    //                     dots: false,
    //                     infinite: false,
    //                     autoplay: false
    //                 });
    //             }
    //         } else {
    //             if ($(".homepage-offer-section-wrapper").hasClass('slick-initialized')) {
    //                 $('.homepage-offer-section-wrapper').slick('unslick');
    //             }
    //         }
    //     })
    // },
    BestSellersProductCarousel: function () {
        $('body').on('init:bestSellerProductCarousel', function () {
            var BestSellersProductCarousel = $('.js-bestsellers-carousel');

            if (!BestSellersProductCarousel.hasClass('slick-initialized')) {
                BestSellersProductCarousel.slick({
                    mobileFirst: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    swipe: true,
                    swipeToSlide: true,
                    centerMode: false,
                    touchMove: true,
                    infinite: true,
                    autoplay: false,
                    responsive: [{
                        breakpoint: 1240,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            dots: false
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            dots: false
                        }
                    }, {
                        breakpoint: 544,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: false
                        }
                    },
                    {
                        breakpoint: 300,
                        settings: {
                            slidesToShow: 2.1,
                            slidesToScroll: 1,
                            infinite: false
                        }
                    }]
                });
            }
        });

        $('body').trigger('init:bestSellerProductCarousel');
        $(window).on('orientationchange', function () {
            setTimeout(function () {
                $('.js-bestsellers-carousel').slick('refresh');
            }, 500);
        })
    },

    rcProductCarousel: function () {
        var rcProductCarousel = $('.js-rc-product-carousel');
        rcProductCarousel.slick({
            mobileFirst: true,
            dots: false,
            infinite: true,
            autoplay: false,
            responsive: [{
                breakpoint: 1239,
                settings: {
                    dots: false
                }
            }, {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    dots: false
                }
            }, {
                breakpoint: 543,
                settings: {
                    slidesToShow: 2,
                    dots: true
                }
            },
            {
                breakpoint: 0,
                settings: {
                    slidesToShow: 4 / 3,
                    dots: true,
                    arrows: false,
                    infinite: false
                }
            }]
        });
    },

    rcImageCarousel: function () {
        var rcImageCarousel = $('.js-rc-image-carousel');
        rcImageCarousel.each(function (index, element) {
            var $rcImageCarouselItem = $(element);
            var customSlideM = parseInt($rcImageCarouselItem.attr("data-slidesToShow_M"));
                customSlideM = customSlideM ? customSlideM : 1;

            if ($(window).width() < 767  && ($rcImageCarouselItem.closest('.rc-image-n-text').length || $rcImageCarouselItem.closest('.rc-text-image-carousel').length)) {
                return false;
            } else {
                $rcImageCarouselItem.slick({
                    mobileFirst: true,
                    dots: false,
                    infinite: true,
                    autoplay: false,
                    responsive: [{
                        breakpoint: 1239,
                        settings: {
                            dots: false
                        }
                    }, {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            dots: false
                        }
                    }, {
                        breakpoint: 543,
                        settings: {
                            slidesToShow: 2
                        }
                    }, {
                        breakpoint: 0,
                        settings: {
                            slidesToShow: (customSlideM + .35),
                            dots: true,
                            arrows: false,
                            infinite: false
                        }
                    }]
                });
            }
        });
    },

    rcBlogCarousel: function () {
        var rcBlogCarousel = $('.js-rc-blog-carousel');
        rcBlogCarousel.slick({
            mobileFirst: true,
            dots: false,
            infinite: true,
            autoplay: false,
            responsive: [{
                breakpoint: 1239,
                settings: {
                    dots: false
                }
            }, {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    dots: false
                }
            }, {
                breakpoint: 543,
                settings: {
                    slidesToShow: 1,
                    dots: true
                }
            },
            {
                breakpoint: 0,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                    infinite: false
                }
            }]
        });
    },

    rcHeroCarousel: function () {
        var rcHeroCarousel = $('.js-rc-hero-carousel');
        rcHeroCarousel.slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: true,
            autoplay: false,
            responsive: [{
                breakpoint: 1239,
                settings: {
                    arrows: true
                }
            }]
        });
    },
    headerPromoCarousel: function () {
        var headerPromoCarousel = $('.promotion-container');
        if ($(headerPromoCarousel).length > 0) {
            headerPromoCarousel.on('init', function(slick) {
                $(document).on('click', '.promo-details', function() {
                    if ($(this).closest('.promo-text-section').find('.promo-detail-container').hasClass('active')) {
                        $(headerPromoCarousel).slick('slickPause');
                    } else {
                        $(headerPromoCarousel).slick('slickPlay');
                    }
                });
                $(document).on('click', '.promo-detail-container.active button', function (e) {
                    e.preventDefault();
                    $(headerPromoCarousel).slick('slickPlay');
                });

                $(headerPromoCarousel).on("beforeChange", function (){
                    $('.logo-section .slot-position').css('top', $('.header-promotion-slot').height() + 5 );
                })
            }).slick({
                infinite: true,
                autoplay: true,
                draggable: false,
                autoplaySpeed: $('.header-promotion-slot').attr('data-promo-sliding-time').length > 0 ? parseInt($('.header-promotion-slot').attr('data-promo-sliding-time')) : '3000',
                speed:  $('.header-promotion-slot').attr('data-promo-sliding-time').length > 0 ? parseInt($('.header-promotion-slot').attr('data-promo-sliding-time')) : '3000',
                slidesToShow: 1,
                swipe: false,
                swipeToSlide: false,
                arrows: false
            });
        }
    }
};